import { render, staticRenderFns } from "./sensoProInput.vue?vue&type=template&id=aaccf5e4&scoped=true"
import script from "./sensoProInput.vue?vue&type=script&lang=js"
export * from "./sensoProInput.vue?vue&type=script&lang=js"
import style0 from "./sensoProInput.vue?vue&type=style&index=0&id=aaccf5e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaccf5e4",
  null
  
)

export default component.exports